import {
  applyCmsImageParams,
  createCmsImageUrlBuilder
} from "@9amhealth/cms-api";
import envVariables from "src/lib/envVariables";

export type { CmsImageOptions } from "@9amhealth/cms-api";

export const cmsImageUrl = createCmsImageUrlBuilder(
  envVariables.CMS_IMAGE_PROXY_URL
);

export { applyCmsImageParams };
